// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label.ant-checkbox-wrapper {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/Tabs/StudentMedicalInformation.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":["label.ant-checkbox-wrapper {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
